export default function FeatureHighlights() {
  const features = [
    {
      icon: 'ri-sd-card-line',
      title: '高清画质',
      desc: '1080P/4K超清画质，每一帧都纤毫毕现，给你影院级观影体验',
    },
    {
      icon: 'ri-speed-up-line',
      title: '流畅不卡顿',
      desc: '智能CDN加速技术，深夜追剧零缓冲，通宵看片更尽兴',
    },
    {
      icon: 'ri-moon-line',
      title: '夜间模式',
      desc: '专为夜猫子设计的深色界面，保护眼睛，长时间观影不疲劳',
    },
    {
      icon: 'ri-global-line',
      title: '海量资源',
      desc: '汇聚全球热门影视，涵盖动作、喜剧、科幻、爱情等全类型',
    },
    {
      icon: 'ri-smartphone-line',
      title: '多端同步',
      desc: '手机、平板、电脑无缝切换，躺在床上也能畅享大屏观影',
    },
    {
      icon: 'ri-shield-check-line',
      title: '安全无毒',
      desc: '采用多重安全防护，无弹窗无广告，纯净观影体验',
    },
  ];

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-900/50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-3">
            为什么选择夜猫影院
          </h2>
          <p className="text-foreground-500 text-sm">深夜观影，我们更懂你</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feat, idx) => (
            <div
              key={idx}
              className="flex gap-4 p-5 rounded-lg bg-background-800/30 border border-background-700/20 hover:border-primary-500/20 transition-all duration-200"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-500/10 flex-shrink-0">
                <i className={`${feat.icon} text-primary-400 text-xl`}></i>
              </div>
              <div>
                <h4 className="text-foreground-200 text-sm font-semibold mb-1">{feat.title}</h4>
                <p className="text-foreground-500 text-xs leading-relaxed">{feat.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}